"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'currency.error.missingCurrencyCode': 'Kod waluty jest wymagany',
    'currency.error.failedToGetRate': 'Nie udało się pobrać kursu waluty',
    'currency.error.missingConversionParams': 'Waluta źródłowa, waluta docelowa i kwota są wymagane',
    'currency.error.invalidAmount': 'Kwota musi być liczbą dodatnią',
    'currency.error.failedToConvert': 'Nie udało się przeliczyć waluty',
    'currency.error.failedToGetCurrencies': 'Nie udało się pobrać listy walut',
    'currency.error.failedToGetSupportedCurrencies': 'Nie udało się pobrać obsługiwanych walut',
    'currency.error.missingHistoricalParams': 'Kod waluty, data początkowa i data końcowa są wymagane',
    'currency.error.invalidDateFormat': 'Format daty musi być YYYY-MM-DD',
    'currency.error.failedToGetHistoricalRates': 'Nie udało się pobrać kursów historycznych',
    'currency.error.failedToGetGoldPrice': 'Nie udało się pobrać ceny złota',
};
